angular.module("safeHtmlFilter", [])
.filter("safeHtml", ["$sce", function ($sce) {
    return function (html, param) {
        return $sce.trustAsHtml(html);
    };
}]);